dealershipModule.factory('dealerDMSSearchService',
    ['$q', 'AppSettings', 'commonRESTCallService','erateSessionVarsService',
        function($q, AppSettings, commonRESTCallService, erateSessionVarsService) {
            var dealerDMSSearchAPI = {};

            dealerDMSSearchAPI.dmsDealData = null;
            /*
             object looks like:
             {
             "customerFirstName": "",
             "customerMiddleName": "",
             "customerLastName": "",
             "businessName": "",
             "customerAddress1": "",
             "customerAddress2": "",
             "customerCity": "",
             "customerState": "",
             "customerZip": "",
             "customerPhone": "",
             "customerEmail": "",
             "dateOfSale": "",
             "vehicleVIN": "",
             "vehicleYear": "",
             "vehicleMake": "",
             "vehicleModel": "",
             "vehicleOdometer": 0,
             "vehiclePurchasePrice": 0,
             "vehicleMSRP": 0,
             "saleAPR": 0,
             "saleTerm": 1,
             "saleAmountFinanced": 0,
             "customerNumber": "",
             "dmsType": "",
             "dealNumber": "",
             "stockNumber": "",
             "isMenuDeal": false,
             "isDMSDeal": true,
             "internalTransactionId": 0
             }
             */
            //search dms deals
            dealerDMSSearchAPI.searchDMS = function(dealNumber, stockNumber){
                var promiseWrapper = $q.defer();

                var dmsSearchUrl = buildDmsSearchUrl(dealNumber, stockNumber);

                doDMSSearch(dmsSearchUrl, promiseWrapper);

                return promiseWrapper.promise;
            }

            //retrieve whether dealer is integrated and the dms type
            dealerDMSSearchAPI.getDealerDMSInformation = function(){
                var prom = $q.defer();

                var dmsDataUrl = new URI(AppSettings.startSPANPlusSvcURL + 'dmsintegration/spandealer/' + erateSessionVarsService.getCurrentDealerSPANId() + '/dmsIntegrationInfo');

                commonRESTCallService.getFromServer(dmsDataUrl.toString())
                    .success(function(responseData, status) {
                        prom.resolve(responseData);
                        //}
                    }).error(function(responseData, status) {
                        prom.reject(responseData);
                    });

                return prom.promise;
            }
            //set up the URL for dms integration
            var buildDmsSearchUrl = function(dealNumber, stockNumber) {
                var searchUrl = new URI(AppSettings.startSPANPlusSvcURL + 'dmsintegration/spandealer/' + erateSessionVarsService.getCurrentDealerSPANId() + '/searchDMSDeal');

                if(stockNumber)
                    searchUrl.addQuery('stocknumber', stockNumber);

                if(dealNumber)
                    searchUrl.addQuery('dealnumber', dealNumber);

                return searchUrl.toString();
            };
            //call the RESTful API to do dms deal search
            var doDMSSearch = function(url, promiseWrapper) {
                commonRESTCallService.getFromServer(url)
                    .success(function(responseData, status) {
                        var results = responseData;
                        var count = 0;
                        if (results.totalItemCount) { count = results.totalItemCount; }

                        if (count == 0){
                            promiseWrapper.reject(false);
                        }else{
                            dealerDMSSearchAPI.dmsDealData = results.itemList;
                            promiseWrapper.resolve(true);
                        }
                    }).error(function(responseData, status) {
                        promiseWrapper.reject(false);
                    });
            }

            return dealerDMSSearchAPI

        }]);
